
<script setup>
const props = defineProps({ blok: Object, slug: String })
const copy = computed(() => renderRichText(props.blok.copy))
</script>
<template>

		<div class="break-inside group pb-6">
				<NuxtLink :to="slug">
					<figure class="overflow-hidden bg-no-repeat rounded-3xl bg-cover">
						<img v-if="blok.image?.filename" loading="lazy"
						:width="375"
						class="rounded-3xl bg-orange-400 w-full group-hover:scale-110 transition duration-300 ease-in-out" :alt="blok.image.alt" 
						:src="blok.image.filename+'/m/375x0'" />
						<div v-else class="bg-orange-200 w-full rounded-3xl aspect-square"></div>
					</figure>
				</NuxtLink>	
				
				<PostCategories :blok="blok.categories" />

				<NuxtLink :to="slug">
					<h3 :to="slug" class="text-xl md:text-2xl mt-4 font-bold hover:text-primary-100 transition-colors duration-300 ease-in-out">{{ blok.title }}</h3>
				</NuxtLink>
				<div class="text-lg md:text-xl mt-4 font-thin" v-html="copy"></div>
		</div>

	
</template>
